import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
    isLoading: false,
    error: null,
    StorageItems: [],
};

const storageSlice = createSlice({
    name: 'storage',
    initialState,
    reducers: {
        startLoading(state) {
            state.isLoading = true;
        },
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        getStorageSuccess(state, action) {
            state.isLoading = false;
            state.StorageItems = action.payload;
        },
    },
});

export default storageSlice.reducer;

export const { startLoading, hasError, getStorageSuccess } = storageSlice.actions;

export const getAllStorages = () => async (dispatch) => {
    dispatch(startLoading());
    try {
        const response = await axios.get('attributes/storage/get-all-storage');
        dispatch(getStorageSuccess(response?.data?.data));
    } catch (error) {
        dispatch(hasError(error));
    }
};

export const addStorage = (Storage) => async (dispatch) => {
    dispatch(startLoading());
    try {
        const currentUser = JSON.parse(localStorage.getItem('currentuser'));
        const response = await axios.post('attributes/storage/storage-add', {
            Storage,
            AddedBy: `${currentUser?.firstName} ${currentUser?.lastName}`,
        })
        dispatch(getAllStorages());
        return response;
    } catch (error) {
        dispatch(hasError(error));
        return error;
    }
};

export const deleteStorage = (id) => async (dispatch) => {
    dispatch(startLoading());
    try {
        await axios.delete(`attributes/storage/storage-delete/${id}`);
        dispatch(getAllStorages());
    } catch (error) {
        dispatch(hasError(error));
    }
};

export const updateStorage = (Storage, id) => async (dispatch) => {
    dispatch(startLoading());
    try {
        const response = await axios.put(`attributes/storage/storage-update/${id}`, {
            Storage,
        });
        dispatch(getAllStorages());
        return response;
    } catch (error) {
        dispatch(hasError(error));
    }
};